var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 264,
    viewBox: "0 0 239 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.325 3.19312C197.627 4.81554 239.799 2.96601 268.82 22.138C297.147 40.8522 304.691 72.1053 306.879 100.672C308.7 124.448 289.551 144.607 279.934 167.26C270.312 189.929 274.388 217.908 250.58 233.3C226.428 248.914 190.626 241.733 159.325 245.235C120.823 249.544 73.737 277.274 46.3432 256.153C17.162 233.655 62.4267 194.529 53.4467 163.603C45.9631 137.83 2.60721 124.187 0.375041 97.8426C-2.24672 66.8997 8.63613 31.531 40.6417 12.4727C72.798 -6.67528 118.622 1.46901 159.325 3.19312Z",
    fill: "#940202",
    fillOpacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble1);
export default __webpack_public_path__ + "static/media/bubble_1.cc49945ef95f9531b0cf4b3e1b774f54.svg";
export { ForwardRef as ReactComponent };